export default __webpack_public_path__ + "static/media/drivability_checker.15e9e588.png";